import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/bags"
    exact
    path="/business/showcase/bags"
    component={AsyncPage}
  />,
];

